module.exports = __webpack_public_path__ + "img/ai-hs-logo.5c0518b5.png";